import React, { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import { useOutletContext } from "react-router-dom";
import ImageInput from "../../../components/WriteProject/ImageInput/ImageInput";
import WpInput from "../../../components/WriteProject/WpInput/WpInput";
import WpTitle from "../../../components/WriteProject/WpTitle/WpTitle";
import { MeetupType } from "../../../interface/interface";
import { PopupChange } from "../../../reducers/config";

function MeetStep1() {
  const patch = useDispatch();
  const {
    state: {
      category,
      mainimg,
      finish_time,
      period: { start, finish },
      leader,
      address,
      title,
      price,
      max,
    },
    isError,
    UpdateCommon,
  }: {
    state: MeetupType;
    dispatch: (p: object) => void;
    isError: boolean;
    UpdateCommon: (type: string, payload: string | number | boolean) => void;
  } = useOutletContext();
  const [isSearch, setIsSearch] = useState(false);

  const __searchLeader = useCallback(() => {
    patch(
      PopupChange({
        active: true,
        type: "leader",
        content: "writeMeetup",
      })
    );
  }, [patch]);
  const __openAddress = useCallback(() => {
    setIsSearch(true);
    new window.daum.Postcode({
      oncomplete: function (data: any) {
        setIsSearch(false);
        UpdateCommon("address", data.roadAddress);
      },
      width: "100%",
      minHeight: "100%",
    }).embed(document.getElementById("postcode"));
  }, [UpdateCommon]);

  return (
    <div className="step1">
      <WpTitle title="기본 정보" />
      <div className="basic-info">
        <div className="left">
          <WpInput
            title="밋업명"
            placeholder="밋업 명을 입력해주세요"
            initial={title}
            max={29}
            type="text"
            reg={"title"}
            __update={UpdateCommon}
            error={
              isError && title.length < 1
                ? "밋업 명을 입력해주세요"
                : undefined
            }
          />
          <div className="category-wrapper">
            <div className="title">
              카테고리 <span>택1</span>
            </div>
            <div className="btn-wrapper">
              {categoryArr.map(({ text, type }, idx) => {
                return (
                  <button
                    key={idx}
                    className={category === type ? "active-category" : ""}
                    onClick={() => {
                      UpdateCommon("category", type);
                    }}
                  >
                    {text}
                  </button>
                );
              })}
            </div>
          </div>
          <div className="period-wrapper">
            <div className="start">
              <WpInput
                title="모집 시작일"
                placeholder="YYYY-MM-DD"
                initial={start}
                max={undefined}
                type="text"
                reg={"start"}
                __update={UpdateCommon}
                error={
                  isError
                    ? isNaN(new Date(start).getTime())
                      ? "유효한 날짜를 입력해주세요"
                      : undefined
                    : undefined
                }
              />
            </div>
            <div className="line">~</div>
            <div className="finish">
              <WpInput
                title="모집 마감일"
                placeholder="YYYY-MM-DD"
                initial={finish}
                max={undefined}
                type="text"
                reg={"finish"}
                __update={UpdateCommon}
                error={
                  isError
                    ? isNaN(new Date(finish).getTime())
                      ? "유효한 날짜를 입력해주세요"
                      : new Date(finish).getTime() <= new Date(start).getTime()
                      ? "시작일 이후의 날짜를 입력해주세요"
                      : undefined
                    : undefined
                }
              />
            </div>
          </div>
          <div className="finish-time-wrapper">
            <WpInput
              title="밋업 시작일"
              placeholder="YYYY-MM-DD"
              initial={finish_time}
              max={undefined}
              type="text"
              reg={"finish_time"}
              __update={UpdateCommon}
              error={
                isError
                  ? isNaN(new Date(finish_time).getTime())
                    ? "유효한 날짜를 입력해주세요"
                    : undefined
                  : undefined
              }
            />
          </div>
          <div className="field-wrapper">
            {category === "OFFLINE" ? (
              <WpInput
                title="모집 인원"
                placeholder="숫자만 입력"
                initial={max}
                max={undefined}
                type="number"
                reg={"max"}
                __update={UpdateCommon}
                error={
                  isError && max < 1 ? "모집 인원을 입력해주세요" : undefined
                }
              />
            ) : undefined}
          </div>
          <div className="leader-wrapper">
            <div className={`select-wrapper`}>
              <div className="title">
                팀 리더명
                <div
                  className={`error-msg ${
                    isError && leader.id.length < 1 ? "active-error" : ""
                  }`}
                >
                  {isError && leader.id.length < 1
                    ? "팀 리더를 선택해주세요"
                    : leader.name}
                </div>
              </div>
              <div
                className={`leader-select ${
                  leader.name ? "choice-leader" : ""
                } ${isError && leader.id.length < 1 ? "select-error" : ""}`}
                onClick={__searchLeader}
              >
                <div className="title">
                  {leader.id
                    ? leader.name
                      ? leader.name
                      : "선택 완료"
                    : "팀 리더 선택"}
                </div>
                <img src="/assets/project/right-arrow.svg" alt="" />
              </div>
            </div>
            <WpInput
              title="팀 리더 추가설명"
              placeholder="예 ) 현 삼성카드 데이터 분석팀 팀장"
              initial={leader.sub}
              max={25}
              type="text"
              reg={"leader/sub"}
              __update={UpdateCommon}
              error={
                isError && leader.sub.length < 1
                  ? "설명을 입력해주세요"
                  : undefined
              }
            />
          </div>
          <div className="price-wrapper">
            <WpInput
              title="참가비"
              placeholder="숫자를 입력해주세요"
              initial={price}
              max={undefined}
              type="text"
              reg={"price"}
              __update={UpdateCommon}
              error={
                isError && price.length < 1
                  ? "참가비를 입력해주세요"
                  : undefined
              }
            />
          </div>
          {category === "OFFLINE" ? (
            <div className="meetup-place-wrapper">
              <div className="select-wrapper">
                <div className="title">
                  밋업 장소
                  <div
                    className={`error-msg ${
                      isError && address.basic.length < 1 ? "active-error" : ""
                    }`}
                  >
                    {isError && address.basic.length < 1
                      ? "주소를 입력해주세요"
                      : undefined}
                  </div>
                </div>
                <div className="leader-select" onClick={__openAddress}>
                  <div className="title">
                    {address.basic ? address.basic : "주소 검색"}
                  </div>
                  <img src="/assets/project/right-arrow.svg" alt="" />
                </div>
                <WpInput
                  title=""
                  placeholder="상세 주소 입력"
                  initial={address.detail}
                  max={undefined}
                  type="text"
                  reg={"ad-detail"}
                  __update={UpdateCommon}
                  error={undefined}
                />
              </div>
            </div>
          ) : undefined}
        </div>
        <div className="right">
          <ImageInput
            title="썸네일 이미지"
            sub="jpg / png 확장자 / 564x475px 권장"
            data={mainimg}
            __update={UpdateCommon}
            isError={isError}
            type="mainimg"
          />
        </div>
      </div>
      <div className={`post-wrapper ${isSearch ? "post-active" : ""}`}>
        <div
          className="back"
          onClick={() => {
            setIsSearch(false);
          }}
        />
        <div className="post-section">
          <img
            src="/assets/common/cancel.svg"
            alt=""
            onClick={() => {
              setIsSearch(false);
            }}
          />
          <div id="postcode"></div>
        </div>
      </div>
    </div>
  );
}

export default MeetStep1;

const categoryArr = [
  { text: "대면", type: "OFFLINE" },
  { text: "비대면", type: "ONLINE" },
];
